export enum ThresholdType {
  CHECK_IN_THRESHOLD = 'CHECK_IN_THRESHOLD',
  CHECK_OUT_THRESHOLD = 'CHECK_OUT_THRESHOLD',
  TIME_BEFORE_NOT_DETECTED = 'TIME_BEFORE_NOT_DETECTED',
  THRESHOLD_FULL = 'THRESHOLD_FULL'
}
